import { SettingsState } from '@/store/modules/settings/settingsState';

const state: SettingsState = {
    rules: [],
    timetable: [],
    visibleTimetableRoles: [],
};

export default state;
